import { render, staticRenderFns } from "./Newsletters.vue?vue&type=template&id=18b366bc&scoped=true"
import script from "./Newsletters.vue?vue&type=script&lang=js"
export * from "./Newsletters.vue?vue&type=script&lang=js"
import style0 from "./Newsletters.vue?vue&type=style&index=0&id=18b366bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b366bc",
  null
  
)

export default component.exports